<template>
  <div>
    <DetailIndex :materialAbnormalCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-userMaterialAbnormal',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
